import React, { useEffect, useRef } from "react";

// SASS
import "./Part1.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS

import educatorImg from "../../assets/img/Educator.png";
import whiteboardImg from "../../assets/img/Whiteboard.png";
import audienceImg from "../../assets/img/Audience.png";
import faceShieldImg from "../../assets/img/Orange-Face-Shield.png";
import greenEyewearImg from "../../assets/img/Green-eyewear.png";

export default function Part1({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "fade out hide--1, fade in reveal--1",
    },
    {
      stepNumber: "2",
      height: null,
      description: "fade in reveal--2, reveal--2a",
    },
    {
      stepNumber: "3",
      height: null,
      description: "fade in reveal--3, reveal--3a",
    },
    { stepNumber: "4", height: null, description: "fade in reveal--4" },
    { stepNumber: "5", height: null, description: "spacer" },
  ];

  // REFS
  const hide1Ref = useRef(null);
  const reveal1Ref = useRef(null);
  const reveal2Ref = useRef(null);
  const reveal2aRef = useRef(null);
  const reveal3Ref = useRef(null);
  const reveal3aRef = useRef(null);
  const reveal4Ref = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnEnter(hide1Ref.current, direction);
            animate.fadeInOnEnter(reveal1Ref.current, direction);
            break;
          }

          case "2": {
            animate.fadeInOnEnter(reveal2Ref.current, direction);
            animate.fadeInOnEnter(reveal2aRef.current, direction);
            break;
          }

          case "3": {
            animate.fadeInOnEnter(reveal3Ref.current, direction);
            animate.fadeInOnEnter(reveal3aRef.current, direction);
            break;
          }
          case "4": {
            animate.fadeInOnEnter(reveal4Ref.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnExit(hide1Ref.current, direction);
            animate.fadeOutOnExit(reveal1Ref.current, direction);
            break;
          }

          case "2": {
            animate.fadeOutOnExit(reveal2Ref.current, direction);
            animate.fadeOutOnExit(reveal2aRef.current, direction);
            break;
          }

          case "3": {
            animate.fadeOutOnExit(reveal3Ref.current, direction);
            animate.fadeOutOnExit(reveal3aRef.current, direction);
            break;
          }
          case "4": {
            animate.fadeOutOnExit(reveal4Ref.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container sticky-container--part1">
        {/* STICKY */}
        <div className="part1">
          {/* PRESENTATION CONTAINER */}
          <div className="presentation">
            <div className="presentation__whiteboard-wrapper">
              <div className="presentation__whiteboard">
                <img src={whiteboardImg} alt="" className="img-fluid" />
                <div className="presentation__speaker">
                  <img src={educatorImg} alt="" className="img-fluid" />
                </div>
                <div className="presentation__text-container">
                  {/* INSERT CONTENT HERE */}
                  <div
                    className="part1__text-box part1__text-box--1 hide hide--1"
                    ref={hide1Ref}
                  >
                    <p className="line-1">Why Should You Use</p>
                    <p className="line-2">EYE PROTECTION?</p>
                  </div>
                  <div
                    className="part1__text-box part1__text-box--2 reveal reveal--1"
                    ref={reveal1Ref}
                  >
                    Eye protection, such as{" "}
                    <span
                      className="bold bold--1 reveal reveal--2"
                      ref={reveal2Ref}
                    >
                      goggles{" "}
                    </span>
                    <span className="reveal reveal--3" ref={reveal3Ref}>
                      or <span className="bold bold--2">face shields</span>,{" "}
                    </span>
                    <span className="reveal reveal--4" ref={reveal4Ref}>
                      is part of the personal protective equipment (PPE)
                      recommended for infectious diseases, like COVID-19.
                    </span>{" "}
                    <div
                      className="icon icon--shield reveal reveal--3a"
                      ref={reveal3aRef}
                    >
                      <img src={faceShieldImg} alt="" className="img-fluid" />
                    </div>
                    <div
                      className="icon icon--goggles reveal reveal--2a"
                      ref={reveal2aRef}
                    >
                      <img src={greenEyewearImg} alt="" className="img-fluid" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="presentation__audience-wrapper">
              <div className="presentation__audience">
                <img src={audienceImg} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
